// extracted by mini-css-extract-plugin
module.exports = {"youTubeVideoPlayer":"YouTubeVideoModal_youTubeVideoPlayer__8pRAG"};